const insurerName = {
    "GENERALI": "Generali Malaysia",
    "LIBERTY": "Liberty General Insurance Berhad",
    "TUNE PROTECT": "Tune Insurance Malaysia Berhad",
    "LONPAC": "Lonpac Insurance Bhd",
    "ETIQA": "Etiqa General Insurance Berhad",
    "ALLIANZ": "Allianz General Company (M) Berhad",
    "TAKAFUL IKHLAS": "Takaful Ikhlas General Berhad",
    "GREAT EASTERN": "Great Eastern General Insurance (Malaysia) Berhad",
    "TAKAFUL MALAYSIA": "Syarikat Takaful Malaysia Am Berhad",
}

export const getInsurerName = (name) => {
    if (name in insurerName) {
        return insurerName[name]
    }
    return name + " Insurance"
}
